import { Col, Row } from "react-bootstrap";
import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";
import BMXQuillArea from "../../../../../../Components/BMXQuillArea/BMXQuillArea";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import { useForm } from "react-final-form";

import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";
const SettingsServiceFormStepOne = ({ initialValues, ...props }) => {

  const { t } = useTranslation();
  const form = useForm();
  return (
    <div className="justify-content-start">
      <Row>
        <Col>
          <BMXSeparator title={t("global:settings.serviceChecklist")} />
        </Col>
      </Row>
      <Row>
        <Col>
          <BMXQuillArea
            content={initialValues?.CHECKLIST_TEXT?.value.value || ""}
            onChangeText={(editor) => {
              form.change("CHECKLIST_TEXT", {
                value: { value: editor.root.innerHTML },
              });
            }}
            className="EmailArea"
          />
        </Col>
      </Row>
    </div>
  );
};

export default SettingsServiceFormStepOne;
